import { PolicyTransaction } from '@/api/geovera/policy/policy-transaction';
import { Button } from '@/components/ui/button';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { ArrowUpDown } from 'lucide-react';

import { UpdatePolicyTransaction } from './sheet-update';

export const columns: ColumnDef<PolicyTransaction>[] = [
	{
		accessorKey: 'policyNumber',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Policy #
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => (
			<div className="whitespace-nowrap font-medium">
				{row.original.policyNumber}
			</div>
		),
	},
	{
		accessorKey: 'policyId',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Sub #
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => (
			<div className="whitespace-nowrap font-medium">{row.original.policyId}</div>
		),
	},
	{
		accessorKey: 'transSummaryId',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Invoice #
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => (
			<div className="whitespace-nowrap font-medium">
				{row.original.transSummaryId}
			</div>
		),
	},
	{
		accessorKey: 'transactionDate',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Invoice Date
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div className="font-medium">
					{row.original.transactionDate
						? format(row.original.transactionDate, 'P')
						: '---'}
				</div>
			);
		},
	},
	{
		accessorKey: 'riskState',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Risk State
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => (
			<div className="font-medium">{row.original.riskState}</div>
		),
	},
	{
		accessorKey: 'premium',
		header: ({ column }) => (
			<div className="text-right">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Premium
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			let formattedAmount;
			if (row.original.premium) {
				formattedAmount = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',
				}).format(row.original.premium);
			}
			return <div className="text-right font-medium">{formattedAmount}</div>;
		},
	},
	{
		accessorKey: 'slTax',
		header: ({ column }) => (
			<div className="text-right">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					SL Tax
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			let formattedAmount;
			if (row.original.slTax) {
				formattedAmount = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',
				}).format(row.original.slTax);
			}
			return <div className="text-right font-medium">{formattedAmount}</div>;
		},
	},
	{
		accessorKey: 'policyFee',
		header: ({ column }) => (
			<div className="text-right">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Policy Fee
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			let formattedAmount;
			if (row.original.policyFee) {
				formattedAmount = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',
				}).format(row.original.policyFee);
			}
			return <div className="text-right font-medium">{formattedAmount}</div>;
		},
	},
	{
		accessorKey: 'inspectionFee',
		header: ({ column }) => (
			<div className="text-right">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Inspection Fee
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			let formattedAmount;
			if (row.original.inspectionFee) {
				formattedAmount = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',
				}).format(row.original.inspectionFee);
			}
			return <div className="text-right font-medium">{formattedAmount}</div>;
		},
	},
	{
		accessorKey: 'retainedPremium',
		header: ({ column }) => (
			<div className="text-right">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Retained Premium
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			let formattedAmount;
			if (row.original.retainedPremium) {
				formattedAmount = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',
				}).format(row.original.retainedPremium);
			}
			return <div className="text-right font-medium">{formattedAmount}</div>;
		},
	},
	{
		accessorKey: 'status',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Status
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => <div className="font-medium">{row.original.status}</div>,
	},
	{
		id: 'actions',
		cell: ({ row }) => (
			<UpdatePolicyTransaction policyTransaction={row.original} />
		),
	},
];
